import React, { useState, useEffect, useContext, useRef } from "react";
import SglContext from "../SglContext";
import "./loginVerification.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import ReactModal from "react-modal";

// IMPORT IMAGES
import indicator_icon from "../images/Indicator.gif";
import tick_icon from "../images/tick_icon.png";
import { getMembershipLogo } from "./membershipLogos";

const AddModal = ReactModal

function LoginVerification(props) {
  const [membershipData, setMembershipData] = useState({
    usef: { number: "", type: "usef" },
    fei: { number: "", type: "fei" },
    ec: { number: "", type: "ec" }
  });
  const [membershipStatus, setMembershipStatus] = useState({
    usef: { error: "", success: false, loading: false },
    fei: { error: "", success: false, loading: false },
    ec: { error: "", success: false, loading: false },
  });
  const [phoneNumber, setPhoneNumber] = useState({
    isValid: false,
    rawValue: null,
    countryData: null,
    formattedValue: "",
    extension: null,
  });
  const [isTyping, setIsTyping] = useState({
    usef: false,
    ec: false,
    fei: false
  });
  const debounceRefs = useRef({
    usef: null,
    ec: null,
    fei: null
  });

  const [currentStep, setCurrentStep] = useState(1);
  const [noMemberships, setNoMemberships] = useState(false);
  const [loading, setLoading] = useState(false);
  const [warning, setWarning] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [verified, setVerified] = useState(false);
  const [lookupData, setLookupData] = useState([]);
  const [verifyPhoneLoading, setverifyPhoneLoading] = useState(false);
  const [useMembershipConfirm, setUseMembershipConfirm] = useState(false); // DISABLE STEP 3
  const [verifyMobileOpenState, setVerifyMobileOpenState] = useState(false);
  const [verificationSkipped, setVerificationSkipped] = useState(false);
  const [excludeCountries, setExcludeCountries] = useState([]);
  const [loadingOtp, setLoadingOtp] = useState(false);
  const [userData, setUserData] = useState(null);
  const [otpError, setOtpError] = useState("");
  const [otp, setOtp] = useState("");
  
  const [dateInputType, setDateInputType] = useState("text");
  const [provisionalVerificationFields, setProvisionalVerificationFields] = useState({
    legalName: { value: "", error: "" },
    dob: { value: "", error: "" },
    email: { value: "", error: "" },
    address: { value: "", error: "" },
    city: { value: "", error: "" },
    state: { value: "", error: "" },
    postalCode: { value: "", error: "" },
    phone: { value: "", error: "" },
  });

  const mismatchDetails = [];
  const navigate = useNavigate();
  const Sgl = useContext(SglContext);

  // API ENDPOINT
  const sgl_webservice_login_verification =  Sgl.nestApiUrl + "/utilities/verifyLoginMembership";
  const sgl_webservice_login_verification_provisional =  Sgl.nestApiUrl + "/utilities/verifyLoginMembershipProvisional";
  const user_info_url = Sgl.nestApiUrl + '/users/getLoggedInUser';
  const sgl_webservice_excluded_countries = Sgl.sglApiUrl + "/iphone.php/webservice/GetRegRestrictedCountries";
  const sgl_webservice_verify_mobile = Sgl.sglApiUrl + "/iphone.php/webservice/VerifyMobilePhone";
  const sgl_webservice_verify_otp = Sgl.sglApiUrl + "/iphone.php/webservice/VerifyOTP";
  const get_pending_verify_user_action =  Sgl.nestApiUrl + "/milestone-actions/getPendingVerifyUserAction";
  const create_and_complete_action_step =  Sgl.nestApiUrl + "/milestone-actions/createAndComplete";

  useEffect(() => {
    // Set step to 2 if user comes from the register page
    if(props.fromRegister) {
      setCurrentStep(2);
    }
  }, [])

  useEffect(() => {
    // Report to GA and setup initial state
    Sgl.reportToGA('/sgl-wp-plugin/' + Sgl.company_urlpath + '/login-verification');
    Sgl.reportToFB('/sgl-wp-plugin/' + Sgl.company_urlpath + '/login-verification');
    setError("");

    if (props.fromRegister) {
      // If coming from registration, use provided userData
      setUserData(props.userData || null);
    } else {
      // Make sure user is logged in
      axios.get(user_info_url)
        .then((response) => {
          // check login
          if (this?.context?.checkLoginOnSGL) {
            this.context.checkLoginOnSGL();
          }
          if (response.data.user) {
            setUserData(response.data.user);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, []);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        axios.get(get_pending_verify_user_action, {
          params: { user_id: userData?.sgl_id, customer_id: Sgl.company_id }
        })
        .then((response) => {
          if (!response.data?.hasPendingAction) {
            navigate(-1); // Go back to previous page if no pending action
          }
        });
      } catch (error) {
        console.error("Error getting pending verify action for user: ", error);
      }
    };

    if (!props.fromRegister && userData?.sgl_id && Sgl?.company_id) {
      checkAccess();
    }
  }, [userData]);

  useEffect(() => {
    if (userData) {
      setProvisionalVerificationFields(prev => ({
        ...prev,
        email: { value: userData.email_address || "", error: "" },
        address: { value: userData.address || "", error: "" },
        city: { value: userData.city || "", error: "" },
        state: { value: userData.state || "", error: "" },
        postalCode: { value: userData.postal_code || "", error: "" },
        phone: { value: userData.phonenumber || "", error: "" },
      }));
    }
  }, [userData]);

  useEffect(() => {
    axios.get(sgl_webservice_excluded_countries)
      .then((response) => {
        setExcludeCountries(response.data);
    })
  },[]);

  const handleVerifyIdentity = () => {
    setCurrentStep(2); // Go directly to the combined membership form
    setError("");
  };

  const createAndCompleteActionStep = (
    step_type,
    description,
    status,
    result,
  ) => {
    axios.post(create_and_complete_action_step, {
      user_id: userData?.sgl_id,
      customer_id: Sgl.company_id,
      step_type,
      description,
      status,
      result,
    });
  }

  const handleSkipAction = () => {
    createAndCompleteActionStep(
      "Skip Verification Prompt",
      "User skipped verification prompt",
      "Skip for Now",
      `Verification of membership skipped for user with ID ${userData?.sgl_id}.`,
    );
  }

  const handleSkipVerification = () => {

    if (
      localStorage.getItem("playing_video_id") &&
      window.referrer != "" &&
      localStorage.getItem("playing_video_url") == window.referrer
    ) {
      navigate(window.referrer);
    } 
    // Now for every case we will redirect to welcome page
    // else if (
    //   window.referrer &&
    //   window.referrer != "" &&
    //   window.referrer !=
    //   "https://" +
    //   window.location.hostname +
    //   "/forgot-password?forgot_password=1"
    // ) {
    //   navigate("/"+window.referrer);
    // } 
    else {
      if(props.company_id == -1){
        navigate('/edit-account')
      }else{
        navigate('/')
      }
    }
  
    // You can handle skip logic here - maybe redirect to main app or show a message
    props.onSkip && props.onSkip();
  };

  const verificationComplete = () => {
    let target = '/';
    if (
      localStorage.getItem("playing_video_id") &&
      window.referrer != "" &&
      localStorage.getItem("playing_video_url") == window.referrer
    ) {
      target = window.referrer;
    } 
    
    // else if (
    //   window.referrer &&
    //   window.referrer != "" &&
    //   window.referrer !=
    //   "https://" +
    //   window.location.hostname +
    //   "/forgot-password?forgot_password=1"
    // ) {
    //   target = "/" + window.referrer;
    // }

    target = target == "/verify-login" || "/registration" ? "/" : target; // Safety check to not redirect onto the same page

    Sgl.setFetchBillingData(!Sgl.fetchBillingData)

    if(
      Sgl.pendingUserOnboardAction?.hasPendingAction &&
      (!Sgl.pendingUserOnboardAction?.defaultPaymentMethod || !Sgl.pendingUserOnboardAction?.hasSignedTOS)
    ){
      navigate('/platform-fee-setup')
    }else if(props.goToPath){
      navigate(props.goToPath);
    }else{
      navigate(target);
    }
    

    // 2. Then update context (if verified)
    if (verified) {
      setTimeout(() => {
        Sgl.setVerificationStatus("verified");
      }, 0);
    }
  };

  const handleMembershipNumberChange = (type, value) => {
    setMembershipData(prev => ({
      ...prev,
      [type]: { ...prev[type], number: value }
    }));
    setMembershipStatus(prev => ({
      ...prev,
      [type]: { error: "", success: false }
    }));
    setError("");
    
    // Set typing status to true
    setIsTyping(prev => ({
      ...prev,
      [type]: true
    }));

    // Clear existing timeout
    if (debounceRefs.current[type]) {
      clearTimeout(debounceRefs.current[type]);
    }

    // Set new timeout for 1.5 seconds
    debounceRefs.current[type] = setTimeout(() => {
      setIsTyping(prev => ({
        ...prev,
        [type]: false
      }));
      
      if (value.trim()) {
        handleMembershipLookup(type, value);
      }
    }, 1500);
  };

  const handleNoMembershipsChange = (checked) => {
    setNoMemberships(checked);
    if (checked) {
      // Clear all membership numbers when no memberships is checked
      setMembershipData({
        usef: { number: "", type: "usef" },
        fei: { number: "", type: "fei" },
        ec: { number: "", type: "ec" }
      });
    }
    setError("");
  };

  // NOTE: USED FOR STEP 3 [DISABLED FOR NOW - BACKEND MAY NEED TO BE UPDATED IF ENABLED]
  const handleMembershipSubmit = (e) => {
    e.preventDefault();
    
    if (!hasAtLeastOneMembership() && !noMemberships) {
      setError("Please enter at least one membership number or confirm that you don't have any memberships");
      return;
    }

    if (props.fromRegister && (!props.userData || !props.userData.first || !props.userData.last_name)) {
      setError("Please provide your first and last name to continue.");
    }

    if (noMemberships) {
      // Skip to success step since no membership verification is needed
      setSuccess(true);
      setCurrentStep(4);
      return;
    }

    setLoading(true);
    setError("");

    // Prepare memberships object with only filled membership numbers
    const memberships = {};
    if (membershipData.usef.number.trim()) {
      memberships.usef = membershipData.usef.number.trim();
    }
    if (membershipData.fei.number.trim()) {
      memberships.fei = membershipData.fei.number.trim();
    }
    if (membershipData.ec.number.trim()) {
      memberships.ec = membershipData.ec.number.trim();
    }

    // API call to lookup membership data with all memberships
    axios.get(sgl_webservice_login_verification, {
      params: {
        memberships: memberships,
        customer_id: Sgl.company_id,
        userData: props?.userData,
      }
    }).then((response) => {
      const data = response.data;

      // Collect errors if present
      if (data.errors && Object.keys(data.errors).length > 0) {
        const errorMessages = Object.values(data.errors).join("<br/>");
        setError(errorMessages);
      }
      else {
        const collectedLookups = [];

        if (data.results) {
          Object.entries(data.results).forEach(([type, result]) => {
            if (result.success) {
              if (result.mismatch) {
                mismatchDetails.push({...result.lookup_person});
              }
              else{ 
                let person = result.lookup_person;
                // Normalize status for UI
                person.status = person.status ? "Active" : "In-Active";

                collectedLookups.push({
                  ...person,
                  type, // keep track of membership type (usef/fei/ec)
                  master_id: result?.lookup_person?.master_id,
                });
              }
            } 
            
          });
        }

        if(mismatchDetails.length > 0) {
          const mismatchInfo = mismatchDetails
            .map(item => `${item.membership_type.toUpperCase()} (${item.membership_number})`)
            .join(', ');

          setError(
            `The name on your profile does not match the name associated with the provided membership numbers for ${mismatchInfo}. Please check and try again.`
          );
        }
        else if (collectedLookups.length > 0 && data.success) {
          setLookupData(collectedLookups);
          setCurrentStep(3);
        }
      }

      setLoading(false);
    }).catch((err) => {
      setError("An error occurred during membership lookup. Please try again.");
      setLoading(false);
    });
  };

  // NOTE: USED FOR STEP 3 [DISABLED FOR NOW]
  const handleVerificationRetry = () => {
    setCurrentStep(2);
    setMembershipData({
      usef: { number: "", type: "usef" },
      fei: { number: "", type: "fei" },
      ec: { number: "", type: "ec" }
    });
    setNoMemberships(false);
    setLookupData(null);
    setError("");
  };

  const hasAtLeastOneMembership = () => {
    return membershipData.usef.number.trim() || 
           membershipData.fei.number.trim() || 
           membershipData.ec.number.trim();
  };

  const handleNoMembershipSubmit = (e) => {
    if (e) e.preventDefault();

    if (props.fromRegister && (!props.userData || !props.userData.first || !props.userData.last_name)) {
      setError("Please provide your first and last name to continue.");
      return;
    }

    if (!props.fromRegister && !userData?.registration_confirmed) {
      setError("Please verify your email before continuing with login verification.");
      return;
    }

    if (!noMemberships) {
      setError("Please acknowledge that you do not hold a membership with any of the organizations.")
      return;
    }

    if (!userData?.sgl_id) {
      setError("Failed to link provisional verification data to your account. Please try again.");
      return;
    }

    if (userData.phonenumber_verified != 1 && (phoneNumber.formattedValue == "" || !phoneNumber.isValid)) {
      setError("Please enter a valid phone number.")
      return;
    }
    
    if (userData?.phonenumber_verified != 1) {
      setError("Please verify phone number first.")
      return;
    }

    setProvisionalVerificationFields(prev => ({ ...prev, phone: { ...prev.phone, value: phoneNumber.formattedValue } }));

    if (Object.values(provisionalVerificationFields).some(field => !field.value)) {
      setError("Please fill all the form fields before continuing.");
      return;
    }

    if (Object.values(provisionalVerificationFields).some(field => field.error)) {
      setError("Please fix the form errors before continuing.");
      return;
    }

    setLoading(true);
    setError("");

    // Prepare data to send in provisional verification call
    const provisionalData = Object.entries(provisionalVerificationFields).reduce((acc, [key, field]) => {
      acc[key] = field.value;
      return acc;
    }, {});

    // Provisional verification
    axios.post(sgl_webservice_login_verification_provisional, {
      loginId: userData?.sgl_id, customer_id: Sgl.company_id, data: provisionalData,
    }).then((response) => {
      if (response.data.success) {
        Sgl.setVerificationStatus("provisional");
        setLoading(false);
        setSuccess(true);
        setCurrentStep(5);
      } else {
        if (props.fromRegister){
          // Account registered successfully but failed provisional verification
          if (userData?.sgl_id) {
            setLoading(false);
            setSuccess(true);
            setWarning("An error occurred during processing. Please log in to try again.");
            setCurrentStep(5);
          } else {
            setLoading(false);
            setError(response?.data?.error || response?.data?.message || "An error occurred during processing. Please try again.");
          }
        } else {
          setLoading(false);
          setError(response?.data?.error || response?.data?.message || "An error occurred during processing. Please try again.");
        }
      }
    }).catch((err) => {
        console.error("Error in provisional verification: ", err);
        setLoading(false);
    });
  };

  const handleVerificationConfirm = async () => {
    setLoading(true);
    setError("");

    // Check if there are any errors from membership lookups
    if (membershipStatus?.usef?.error || membershipStatus?.ec?.error || membershipStatus?.fei?.error) {
      setError("Please address membership lookup errors first.")
      setLoading(false);
      return;
    }

    // Check if atleast one membership number has been entered
    if (!hasAtLeastOneMembership() && !noMemberships) {
      setError("Please enter at least one membership number or continue with provisional verification");
      setLoading(false);
      return;
    }

    // Check if user data is set up properly from the registration page
    if (props.fromRegister && (!props.userData || !props.userData.first || !props.userData.last_name)) {
      setError("Please provide your first and last name to continue.");
      setLoading(false);
      return;
    }

    if (!userData.sgl_id) {
      setError("Failed to link membership data to your account. Please try again.");
      setLoading(false);
    } else {
      // API call to lookup membership data
      axios.post(sgl_webservice_login_verification, {
          loginId: userData?.sgl_id, customer_id: Sgl.company_id, lookupData
      }).then((response) => {
        if (response.data.success) {
          setVerified(true);
          setSuccess(true);
          setCurrentStep(5);
          setLoading(false);
        } else {
          if (props.fromRegister){
            // Account registered successfully but unable to verify membership(s)
            if (userData?.sgl_id) {
              setWarning("An error occurred during data verification. Please log in to try again.");
              setSuccess(true);
              setLoading(false);
              setCurrentStep(5);
            } else {
              setError(response?.data?.error || response?.data?.message || "An error occurred during data verification. Please try again.");
            }
          } else {
            setError(response?.data?.error || response?.data?.message || "An error occurred during data verification. Please try again.");
          }
        }
        setLoading(false);
      }).catch((err) => {
        setError("An error occurred during data verification. Please try again.");
        setLoading(false);
      });
    }
  };

  const resetVerification = () => {
    setCurrentStep(1);
    setMembershipData({
      usef: { number: "", type: "usef" },
      fei: { number: "", type: "fei" },
      ec: { number: "", type: "ec" }
    });
    setNoMemberships(false);
    setError("");
    setSuccess(false);
    setLookupData(null);
    setVerificationSkipped(false);
  };

  // Helper function to check if any membership fields are filled
  const hasMembershipData = () => {
    return membershipData.usef.number.trim() !== '' || 
          membershipData.ec.number.trim() !== '' || 
          membershipData.fei.number.trim() !== '';
  };

  const handleMembershipLookup = (membershipType, membershipNumber) => {
    if (membershipNumber == "") return;

    setMembershipStatus(prev => ({
        ...prev,
        [membershipType]: { loading: true }
      })
    );

    setLoading(true);
    setError("");

    // Prepare memberships object with only filled membership numbers
    if (membershipNumber.trim()) {
      membershipNumber = membershipNumber.trim();
    }

    // API call to lookup membership data with all memberships
    axios.get(sgl_webservice_login_verification, {
      params: {
        membershipType,
        membershipNumber,
        customer_id: Sgl.company_id,
        userData: props?.userData,
      }
    }).then((response) => {
      const data = response.data;

      // Collect errors if present
      if (data?.error) {
        setMembershipStatus(prev => ({
            ...prev,
            [membershipType]: { error: data?.error ?? `An error occurred during ${membershipType?.toUpperCase()} membership lookup. Please try again.`, success: false, loading: false }
          })
        );
        setLoading(false);
      }
      else {
        let collectedLookups = {};
        if (data?.success) {
          let person = data?.lookup_person;
          if (data?.mismatch) {
            setMembershipStatus(prev => ({
                ...prev,
                [membershipType]: { error: `The name on your profile does not match the name associated with the provided membership numbers for ${membershipType?.toUpperCase()} ${person?.membership_number}. Please check and try again.`, success: false, loading: false }
              })
            );
            setLoading(false);
            return;
          } else { 
            // Normalize status for UI
            person.status = person.status ? "Active" : "In-Active";

            collectedLookups = {
              ...person,
              master_id: data?.lookup_person?.master_id,
            };
          }
        } else {
          setMembershipStatus(prev => ({
              ...prev,
              [membershipType]: { error: data?.error ?? `An error occurred during ${membershipType?.toUpperCase()} membership lookup. Please try again.`, success: false, loading: false }
            })
          );
          setLoading(false);
          return;
        }

        // Success
        lookupData.push(collectedLookups);
        setMembershipStatus(prev => ({
            ...prev,
            [membershipType]: { error: "", success: true, loading: false }
          })
        );
      }
      setLoading(false);
    }).catch((err) => {
      console.error("Error in membership lookup: ", err)
      setError("An error occurred during membership lookup. Please try again.");
      setLoading(false);
    });
  };

  // Helper function to check if any user is currently typing
  const isAnyUserTyping = () => {
    return Object.values(isTyping).some(typing => typing);
  };

  function handlePhoneNumberBlur() {
    if (phoneNumber.formattedValue != "" && !phoneNumber.isValid) {
      setProvisionalVerificationFields(prev => ({ ...prev, phone: { ...prev.phone, error: "Please enter a valid phone number." } }));
    }
  }

  function handlePhoneNumberChange(
    _isValid,
    _rawValue,
    _countryData,
    _formattedValue,
    _extension
  ) {
    setProvisionalVerificationFields(prev => ({ ...prev, phone: { ...prev.phone, error: "" } }));

    setPhoneNumber({
      isValid: _isValid,
      rawValue: _rawValue,
      countryData: _countryData,
      formattedValue: _formattedValue,
      extension: _extension,
    });
  }

  async function verifyPhoneNumber() {
    if (phoneNumber.formattedValue == "" || !phoneNumber.isValid) {
      return;
    }

    setverifyPhoneLoading(true);

    axios
      .get(sgl_webservice_verify_mobile, {
        params: {
          mobile_phone: phoneNumber.formattedValue,
          dial_code: phoneNumber.countryData.dialCode
        },
      })
      .then((response) => {
        if (response.data.result) {
          setVerifyMobileOpenState(true);
          setverifyPhoneLoading(false);
        } else {
          setError("An error occurred during phone number verification. Please try again.");
          setverifyPhoneLoading(false);
        }
      })
      .catch(() => {
        setError("An error occurred during phone number verification. Please try again.");
        setverifyPhoneLoading(false);
      });
  }

  const verifyOTP = () => {
    setLoadingOtp(true);
    setOtpError("");

    axios
      .get(sgl_webservice_verify_otp, {
        params: { otp },
      })
      .then((response) => {
        setLoadingOtp(false);
        if (response.data.result) {
          setVerifyMobileOpenState(false);
          setverifyPhoneLoading(false);
          setUserData((prev) => ({
            ...prev,
            phonenumber_verified: 1,
          }));
        } else {
          setOtpError(response.data.error);
          setverifyPhoneLoading(false);
        }
      })
      .catch(() => {
        setLoadingOtp(false);
        setverifyPhoneLoading(false);
        setOtpError("An error occurred during OTP verification. Please try again.");
      });
  };

  const closeVerifyMobile = (e) => {
    e.preventDefault();
    setVerifyMobileOpenState(false);
    setverifyPhoneLoading(false);
    setLoadingOtp(false);
  };

  const handleOTPChange = (e) => {
    setOtpError("");
    setOtp(e.target.value);
  }

  const validateAge = (dateString) => {
    if (!dateString) {
      setProvisionalVerificationFields(prev => ({
        ...prev,
        dob: { ...prev.dob, error: "" },
      }));
      return;
    };

    const birthDate = new Date(dateString);
    const today = new Date();
    
    // Calculate age
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    // Adjust age if birthday hasn't occurred this year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    if (age < 10) {
      setProvisionalVerificationFields(prev => ({
        ...prev,
        dob: { ...prev.dob, error: "You must be at least 10 years old to continue." },
      }));
      return false;
    }

    setProvisionalVerificationFields(prev => ({
      ...prev,
      dob: { ...prev.dob, error: "" },
    }));
    return true;
  };

  const handleDobBlur = (e) => {
    setProvisionalVerificationFields(prev => ({ ...prev, dob: { value: e.target.value } }));
    validateAge(e.target.value);
  };

  // Return early if verification was skipped
  if (verificationSkipped) {
    return (
      <div className="sgl-content-wrapper loginverificationcss">
        <div className="sgl-plugin">
          <div className="div-responsive loginverificationcss">
            <div className="registration-container">
              <div className="verification-skip-header">
                <div className="verification-skip-content">
                  {props.fromRegister ? <h2>Registration Complete</h2> : <h2>Verification Skipped</h2>}
                  {props.fromRegister ? <p className="skip-subtitle">Some features may be limited until verified</p> : <p className="skip-subtitle">You can complete this process later</p>}
                </div>
              </div>

              <div className="skip-message-content">
                <div className="skip-info-box">                  
                  {props.fromRegister ? (
                    <div className="skip-info-group">
                      <div className="skip-info-icon">
                        <span>⭐️</span>
                      </div>
                      <div className="skip-info-text">
                        <h3>Thank you for registering for {Sgl.company_name}</h3>
                        <p>A confirmation email has been sent to you. You must access your email and confirm the registration prior to logging in.</p>
                      </div>
                    </div>
                  ) 
                  : null}
                  <div className="skip-info-group">
                    <div className="skip-info-icon">
                      <span>⭐️</span>
                    </div>
                    <div className="skip-info-text">
                      <h3>Identity Verification Postponed</h3>
                      <p>You have chosen to skip identity verification. You can verify your identity later from your account settings to unlock all features.</p>
                    </div>
                  </div>
                </div>

                <div className="skip-limitations">
                  <h4>Current Limitations:</h4>
                  <ul>
                    <li>Event registration may be restricted</li>
                    <li>Some premium features unavailable</li>
                    <li>Competition records may not be linked</li>
                  </ul>
                </div>

                <div className="skip-actions">
                  {props.fromRegister ? null : (
                    <div className="submit">
                      <button 
                        className="button primary-button"
                        onClick={resetVerification}
                      >
                        Verify Now Instead
                      </button>
                    </div>
                  )}

                  <div className="submit">
                    <button 
                      className= {props.fromRegister ? "button primary-button" : "button secondary-button"}
                      onClick={() => props.onComplete ? props.onComplete() : handleSkipVerification()}
                    >
                      {props.fromRegister ? "Continue" : "Continue Without Verification"}                      
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="sgl-content-wrapper loginverificationcss">
      <div className="sgl-plugin">
        {/* <div className="registration_header">
          <h1>{Sgl.company_name} - LOGIN VERIFICATION</h1>
        </div>
        
        <div className="credit-text">
          {process.env.REACT_APP_CREDIT_TEXT}{" "}
          <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}>
            {process.env.REACT_APP_CREDIT_COMPANY}
          </a>
        </div> */}
        
        <br />

        {/* Step 1: Identity Verification Introduction */}
        {currentStep === 1 && (
          <div className="div-responsive loginverificationcss">
            <div className="registration-container">
              <div className="registration-container">
                <div className="verification-intro-header">
                  <div className="verification-intro-content">
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'relative',
                      }}
                    >
                      <h2 style={{ margin: 0 }}>Verify Your Identity</h2>
                    </div>
                    <p className="intro-subtitle">
                      Secure your account and unlock all features
                    </p>
                  </div>
                </div>
              </div>


              <div className="verification-benefits">
                <div className="benefit-item">
                  <div className="benefit-icon green">
                    <img src={tick_icon} alt="Check" />
                  </div>
                  <div className="benefit-content">
                    <h3>Event Registration</h3>
                    <p>Required for all future event participation</p>
                  </div>
                </div>
                <div className="benefit-item">
                  <div className="benefit-icon blue">
                    <img src={tick_icon} alt="Globe" />
                  </div>
                  <div className="benefit-content">
                    <h3>Enhanced Features</h3>
                    <p>Access advanced tools and premium features</p>
                  </div>
                </div>
                <div className="benefit-item">
                  <div className="benefit-icon purple">
                    <img src={tick_icon} alt="Shield" />
                  </div>
                  <div className="benefit-content">
                    <h3>Account Security</h3>
                    <p>Protect your account and competition records</p>
                  </div>
                </div>
              </div>

              <div className="verification-info-box">
                <div className="info-content">
                  <p>Identity verification helps us maintain the integrity of our competitions and ensures accurate record-keeping across all equestrian organizations.</p>
                </div>
              </div>

              <div className="loginverificationcss verification-row">
                {
                  props.hideSkipButton ? <span className="radio-text-start"></span> :
                  <span
                    onClick={async () => {
                      setVerificationSkipped(true);
                      await handleSkipAction(); // Log action step for skipping verification
                    }} 
                    className="radio-text-start"
                  >
                    Skip for now
                  </span>

                }

                <div className="verification-intro-buttons">
                  <div className="submit">
                    <button
                      className="button primary-button"
                      onClick={handleVerifyIdentity}
                    >
                      Verify Now →
                    </button>
                  </div>
                </div>
              </div>

              <p className="verification-note">
                Note: If you only need access to view content, verification may not be required.
              </p>
            </div>
          </div>
        )}

        {/* Step 2: Combined Membership Form */}
        {currentStep === 2 && (
          <div className="div-responsive loginverificationcss">
            <div className="registration-container">
              <div className="step-header">
                {props.fromRegister ? null : (
                  <button 
                    className="back-button"
                    onClick={() => {setCurrentStep(1)}}
                    disabled={loading}
                  >
                    ← Back
                  </button>                
                )}
                <div className="step-header-content">
                  <h2>Enter Membership Information</h2>
                  <p className="step-subtitle">Provide details for any memberships you have</p>
                </div>
                <div className="step-header-spacer"></div>
              </div>

              <div className="verification-form">
                <div className="verification-privacy-info">
                  <p>This information is only used to verify your identity and link your account to official records.</p>
                </div>

                {/* USEF Membership */}
                <div className={`membership-section ${membershipStatus?.usef?.error ? 'error' : membershipStatus?.usef?.success ? 'successful' : ''}`}>
                  <div className="membership-section-header">
                    <h3> {getMembershipLogo("usef", 30)} &nbsp; United States Equestrian Federation (USEF) </h3>
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Enter your USEF Membership Number"
                      value={membershipData.usef.number}
                      onChange={(e) => handleMembershipNumberChange("usef", e.target.value)}
                      className="form-input"
                      disabled={membershipStatus?.usef?.loading}
                    />
                    <div className="svg-icons">
                      {membershipStatus?.usef?.success ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="#00d05a" strokeWidth="3">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 3L17 7" />
                        </svg>
                      ) : membershipStatus?.usef?.loading ? (
                        <svg className="loading-spinner" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3">
                          <circle className="spinner-circle" cx="12" cy="12" r="10" strokeOpacity="0.25" />
                          <path className="spinner-path" d="M22 12a10 10 0 0 1-10 10"/>
                        </svg>
                      ) : null}
                      </div>
                  </div>
                  {membershipStatus?.usef?.error && (
                    <div className="error_container">
                      <p className="error_summary reg_error_summary" dangerouslySetInnerHTML={{ __html: membershipStatus?.usef?.error }} />
                    </div>
                  )}
                </div>

                {/* Equestrian Canada */}
                <div className={`membership-section ${membershipStatus?.ec?.error ? 'error' : membershipStatus?.ec?.success ? 'successful' : ''}`}>
                  <div className="membership-section-header">
                    <h3> {getMembershipLogo("ec", 30)} &nbsp; Equestrian Canada (EC) </h3>
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Enter your EC Sport License Number"
                      value={membershipData.ec.number}
                      onChange={(e) => handleMembershipNumberChange("ec", e.target.value)}
                      className="form-input"
                      disabled={membershipStatus?.ec?.loading}
                    />
                    <div className="svg-icons">
                      {membershipStatus?.ec?.success ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="#00d05a" strokeWidth="3">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 3L17 7" />
                        </svg>
                      ) : membershipStatus?.ec?.loading ? (
                        <svg className="loading-spinner" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3">
                          <circle className="spinner-circle" cx="12" cy="12" r="10" strokeOpacity="0.25" />
                          <path className="spinner-path" d="M22 12a10 10 0 0 1-10 10"/>
                        </svg>
                      ) : null}
                    </div>
                  </div>
                  {membershipStatus?.ec?.error && (
                    <div className="error_container">
                      <p className="error_summary reg_error_summary" dangerouslySetInnerHTML={{ __html: membershipStatus?.ec?.error }} />
                    </div>
                  )}
                </div>

                {/* FEI Registration */}
                <div className={`membership-section ${membershipStatus?.fei?.error ? 'error' : membershipStatus?.fei?.success ? 'successful' : ''}`}>
                  <div className="membership-section-header">
                    <h3> {getMembershipLogo("fei", 30)} &nbsp; Fédération Equestre Internationale (FEI) </h3>
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Enter your FEI ID"
                      value={membershipData.fei.number}
                      onChange={(e) => handleMembershipNumberChange("fei", e.target.value)}
                      className="form-input"
                      disabled={membershipStatus?.fei?.loading}
                    />
                    <div className="svg-icons">
                      {membershipStatus?.fei?.success ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="2 0 24 24" stroke="#00d05a" strokeWidth="3">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 3L17 7" />
                        </svg>
                      ) : membershipStatus?.fei?.loading ? (
                        <svg className="loading-spinner" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3">
                          <circle className="spinner-circle" cx="12" cy="12" r="10" strokeOpacity="0.25" />
                          <path className="spinner-path" d="M22 12a10 10 0 0 1-10 10"/>
                        </svg>
                      ) : null}
                    </div>
                  </div>
                  {membershipStatus?.fei?.error && (
                    <div className="error_container">
                      <p className="error_summary reg_error_summary" dangerouslySetInnerHTML={{ __html: membershipStatus?.fei?.error }} />
                    </div>
                  )}
                </div>

                <div className="actions-row">
                  {props.fromRegister ?
                    <span onClick={async () => {
                        setVerificationSkipped(true);
                        await handleSkipAction(); // Log action step for skipping verification
                      }} 
                      className="radio-text"
                      >
                      Skip for now
                    </span>
                    : <div />
                  }

                  <div className="full submit">
                    <button
                      type="button"
                      className = {
                        `button primary-button ${props.fromRegister ? 'primary-button-no-full-width' : ''} ${
                        membershipStatus?.usef?.loading || membershipStatus?.ec?.loading || membershipStatus?.fei?.loading || isAnyUserTyping() ? 'disabled'
                        : loading ? 'button-loading'
                        : '' 
                      }`
                    }
                      disabled={loading || isAnyUserTyping()}
                      onClick={(e) => {
                        if (useMembershipConfirm) {
                          handleMembershipSubmit(e);
                        } else {
                          handleVerificationConfirm();
                        }
                      }}
                    >
                      <span className="btn-text">Confirm</span>

                      <svg className="loading-spinner" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3">
                        <circle className="spinner-circle" cx="12" cy="12" r="10" strokeOpacity="0.25" />
                        <path className="spinner-path" d="M22 12a10 10 0 0 1-10 10"/>
                      </svg>
                    </button>
                  </div>
                </div>

                {error && (
                  <div className="error_container">
                    <p className="error_summary reg_error_summary" dangerouslySetInnerHTML={{ __html: error }} />
                  </div>
                )}

                {/* Provisional Verification Option */}
                <div className="alternative-verification-section">
                  <div className="divider-with-text">
                    <div className="divider-line"></div>
                    <span className="divider-text">OR</span>
                    <div className="divider-line"></div>
                  </div>
                  <div 
                    className={`alternative-option-card ${hasMembershipData() ? 'disabled' : ''}`}
                    onClick={async () => {
                      if (!loading && !hasMembershipData()) {
                        setCurrentStep(4);
                        createAndCompleteActionStep(
                          "Initiate Provisional Verification",
                          "User opted for provisional verification.",
                          "Complete",
                          `Provisional verification process initiated for user with ID ${userData?.sgl_id}.`,
                        );
                      }
                    }}>
                    <div className="alternative-option-header">
                      <div className="verification-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="#059669" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      <h3>Provisional Verification</h3>
                    </div>
                    <p className="alternative-description">
                      Don't have any of the memberships listed above? You can still complete your account setup.
                    </p>
                    <div className={`radio-option ${hasMembershipData() ? 'disabled' : ''}`}>
                      <label htmlFor="no-memberships" className={`radio-label ${hasMembershipData() ? 'disabled' : '' }`}>
                        <span className={`radio-text ${hasMembershipData() ? 'disabled' : ''}`}>Continue without setting up memberships</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Step 3: Verification Confirmation | NOTE: DISABLED FOR NOW */}
        {currentStep === 3 && lookupData.length > 0 && (
          <div className="div-responsive">
            <div className="registration-container">
              <div className="verification-confirmation-header">
                {error && mismatchDetails.length > 0 ? (
                  <div className="mismatch-header">
                    <div>
                      <h2>Membership Mismatch</h2>
                      <p>The information provided doesn't match our records</p>
                    </div>
                  </div>
                ) : error ? (
                  <div>
                    <h2>Identity Verification Failed</h2>
                  </div>
                ) : (
                  <div>
                    <h2>Verify Your Information</h2>
                    <p>Please confirm that this information matches your identity</p>
                  </div>
                )}
              </div>

              {error ? (
                <div className="mismatch-content">
                  <div className="mismatch-message">
                    <div className="mismatch-details">
                      <p dangerouslySetInnerHTML={{ __html: error }} />
                    </div>
                  </div>
                </div>
              ) : (
                lookupData.map((entry, index) => (
                  <div key={index} className="lookup-data">
                    <div className="lookup-data-header">
                      <h4 className="lookup-data-name">{entry.name}</h4>
                      <span className="lookup-data-type">
                        {entry.type === "usef" ? "USEF" : 
                        entry.type === "fei" ? "FEI" : 
                        entry.type === "ec" ? "EC" : "Unknown"}
                      </span>
                    </div>
                    <div className="lookup-data-details">
                      <div className="lookup-detail-group">
                        <span className="data-field-label">MEMBERSHIP NUMBER</span>
                        <span className="data-field-value">{entry.membership_number}</span>
                      </div>
                      <div className="lookup-detail-group">
                        <span className="data-field-label">STATUS</span>
                        <span className={`data-field-value ${entry.status?.toLowerCase() === 'active' ? 'status-active' : ''}`}>
                          {entry.status}
                        </span>
                      </div>
                      <div className="lookup-detail-group">
                        <span className="data-field-label">Expiry Date</span>
                        <span className="data-field-value">{entry.expiry_date || 'N/A'}</span>
                      </div>
                      <div className="lookup-detail-group">
                        <span className="data-field-label">TYPE</span>
                        <span className="data-field-value">
                          {entry.type === "usef" ? "USEF" : 
                          entry.type === "fei" ? "FEI" : 
                          entry.type === "ec" ? "Equestrian Canada" : "Unknown"}
                        </span>
                      </div>
                    </div>
                  </div>
                ))
              )}

              {!error && (
                <div className="verification-question">
                  <p>Is this information correct and matches your identity?</p>
                </div>
              )}

              <div className="verification-buttons">
                <div className="submit">
                  <button
                    className="verification-retry-button"
                    onClick={handleVerificationRetry}
                  >
                    Try Again
                  </button>
                </div>

                {!error && (
                  <div className="submit">
                    <button
                      className="verification-confirm-button"
                      onClick={handleVerificationConfirm}
                    >
                      {loading ? (
                        <span>
                          <img src={indicator_icon} alt="Loading" /> Processing...
                        </span>
                      ) : (
                        <span>
                          <img src={tick_icon} alt="Confirm" /> Yes, this is Correct
                        </span>
                      )}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Step 4: Phone Number Verification */}
        {currentStep === 4 && (
          <div className="div-responsive loginverificationcss">
            <div className="registration-container">
              <div className="step-header">
                <button 
                  className="back-button"
                  onClick={() => {
                    setError("");
                    setCurrentStep(2);
                  }}
                  disabled={loading}
                >
                  ← Back
                </button>
                <div className="step-header-content">
                  {userData.phonenumber_verified == 1 ? <h2>Provisional Verification</h2> : <h2>Provisional Verification</h2>}
                  {userData.phonenumber_verified == 1 ? <p className="step-subtitle"></p> : <p className="step-subtitle"></p>}
                </div>
                <div className="step-header-spacer"></div>
              </div>

              <div className="verification-form">
                <div className="">
                    {userData?.phonenumber_verified == 1 ? 
                      <p>Please fill the form below to continue with provisional verification.</p>
                      :
                      <div>
                        <p>Please fill the form below to continue with provisional verification. <br></br>
                        Enter your complete number including country code i.e +1 (828) 202-8116.</p>
                      </div>
                    }
                </div>

                {/* Phone Verification */}
                <div className="form-group-phone full">
                  <label> {userData?.first} {userData?.last_name} </label>
                </div>

                {userData?.registration_confirmed ? ( // User coming from login page with registration confirmation
                  <div className="form-group-phone full">
                    <label> {userData?.email_address} </label>
                    <div className="svg-icons">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="-5 0 24 24" stroke="#00d05a" strokeWidth="3">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 3L17 7" />
                      </svg>
                    </div>
                  </div>
                ) : props.fromRegister ? ( // User coming from the registration page
                  <div className="form-group-phone full">
                    <label> {userData?.email_address} </label>
                  </div>
                ) : ( // User coming from login page but without registration confirmation. NOTE: SHOULD NOT OCCUR UNDER NORMAL CIRCUMSTANCES
                  <div>
                  <div className="form-group-phone full">
                      <input
                        type="email"
                        placeholder="Email"
                        value={provisionalVerificationFields?.email?.value}
                        disabled={userData?.registration_confirmed || loading}
                      />
                      <div className="svg-icons"/>
                    </div>
                  </div>
                )}

                <div className="verification-row form">
                  <div className="form-group-phone">
                    <input
                      type="text"
                      placeholder="Full Legal Name"
                      onChange={(e) => {setProvisionalVerificationFields(prev => ({ ...prev, legalName: { value: e.target.value }}))}}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          setProvisionalVerificationFields(prev => ({ ...prev, legalName: { ...prev.legalName, error: "Full Legal Name cannot be empty." } }))
                        } else {
                          setProvisionalVerificationFields(prev => ({ ...prev, legalName: { ...prev.legalName, error: "" } }))
                        }
                      }}
                      disabled={loading}
                    />
                    <div className="svg-icons placeholder"/>
                  </div>

                  <div className="form-group-phone">
                    <input
                      type={dateInputType}
                      placeholder="Date of Birth"
                      onFocus={() => setDateInputType("date")}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          setDateInputType("text");
                        } else {
                          handleDobBlur(e);
                        }
                      }}
                      disabled={loading}
                    />
                    <div className="svg-icons"/>
                  </div>
                </div>

                <div className="form-group-phone full">
                  <input
                    type="text"
                    placeholder="Address"
                    value={provisionalVerificationFields?.address?.value}
                    onChange={(e) => setProvisionalVerificationFields(prev => ({ ...prev, address: { value: e.target.value } }))}
                    onBlur={(e) => {
                      if (!e.target.value) {
                        setProvisionalVerificationFields(prev => ({ ...prev, address: { error: "Address cannot be empty." } }))
                      }
                    }}
                    disabled={loading}
                  />
                  <div className="svg-icons"/>
                </div>

                <div className="verification-row form">
                  <div className="form-group-phone">
                    <input
                      type="text"
                      placeholder="City"
                      value={provisionalVerificationFields?.city?.value}
                      onChange={(e) => setProvisionalVerificationFields(prev => ({ ...prev, city: { value: e.target.value } }))}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          setProvisionalVerificationFields(prev => ({ ...prev, city: { error: "City cannot be empty." } }))
                        }
                      }}
                      disabled={loading}
                    />
                    <div className="svg-icons placeholder"/>
                  </div>

                  <div className="form-group-phone">
                    <input
                      type="text"
                      placeholder="State"
                      value={provisionalVerificationFields?.state?.value}
                      onChange={(e) => setProvisionalVerificationFields(prev => ({ ...prev, state: { value: e.target.value } }))}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          setProvisionalVerificationFields(prev => ({ ...prev, state: { error: "State cannot be empty." } }))
                        }
                      }}
                      disabled={loading}
                    />
                    <div className="svg-icons"/>
                  </div>
                </div>

                <div className="verification-row form">
                  <div className="form-group-phone">
                    <input
                      type="text"
                      value={provisionalVerificationFields?.postalCode?.value}
                      placeholder="Postal Code"
                      onChange={(e) => setProvisionalVerificationFields(prev => ({ ...prev, postalCode: { value: e.target.value } }))}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          setProvisionalVerificationFields(prev => ({ ...prev, postalCode: { error: "Postal code cannot be empty." } }))
                        }
                      }}
                      disabled={loading}
                    />
                    <div className="svg-icons placeholder"/>
                  </div>

                  {userData?.phonenumber && userData.phonenumber_verified == 1 ? (
                    <div className="form-group-phone disabled">
                        <IntlTelInput
                          style={{
                            width: "100%",
                          }}
                          preferredCountries={["us", "ca"]}
                          initialCountry={"us"}
                          allowDropdown={true}
                          onPhoneNumberChange={handlePhoneNumberChange}
                          value={userData?.phonenumber}
                          disabled={true}
                          id='telephone-input'
                          excludeCountries={excludeCountries}
                        />
                      <div className="svg-icons">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="-5 0 24 24" stroke="#00d05a" strokeWidth="3">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 3L17 7" />
                        </svg>
                      </div>
                    </div>
                  ) : (
                    <div className="form-group-phone">
                      <IntlTelInput
                        style={{
                          width: "100%",
                        }}
                        preferredCountries={["us", "ca"]}
                        initialCountry={"us"}
                        allowDropdown={true}
                        onPhoneNumberChange={handlePhoneNumberChange}
                        onPhoneNumberBlur={handlePhoneNumberBlur}
                        placeholder='Mobile Number'
                        id='telephone-input'
                        excludeCountries={excludeCountries}
                        disabled={loading}
                      />
                      <div className="svg-icons"/>
                    </div>                      
                  )}
                </div>

                {userData.phonenumber_verified == 1 ? null : (
                  <div className="verify-phone-submit">
                    <span className="radio-text-end" onClick={verifyPhoneNumber}>
                      Verify Mobile
                    </span>
                  </div>
                )}

                {/* OTP Modal */}
                <div>
                  <AddModal
                    isOpen={verifyMobileOpenState}
                    onRequestClose={closeVerifyMobile}
                    className="mymodal"
                    overlayClassName="myoverlay"
                    ariaHideApp={false}
                  >
                    <h2>Verify Mobile</h2>
                    <p>Please enter Verification Code</p>
                    {otpError && (
                      <div className="error_container" style={{color: "#FF0000"}}>
                        <p className="error_summary reg_error_summary" dangerouslySetInnerHTML={{ __html: otpError }} />
                      </div>
                    )}
                    <input
                      type="text"
                      maxLength="5"
                      value={otp}
                      onChange={handleOTPChange}
                      className="otp"
                      placeholder="Verification Code"
                    />
                    <div>
                      <button
                        onClick={closeVerifyMobile}
                        className="verify_mobile_buttons left"
                      >
                        Close
                      </button>
                      <button
                        onClick={verifyOTP}
                        className="verify_mobile_buttons right"
                        disabled={loadingOtp}
                      >
                        {loadingOtp ? "Processing..." : "Verify"}
                      </button>
                      {loadingOtp && (
                        <span className="verify_otp-please-wait right">
                          <img src={indicator_icon} alt="loading" /> Processing...
                        </span>
                      )}
                    </div>
                  </AddModal>
                </div>

                {Object.values(provisionalVerificationFields).some(field => field.error) && (
                  <div className="error_container">
                    {Object.entries(provisionalVerificationFields).map(([fieldName, fieldData]) => 
                      fieldData.error ? (
                        <p key={fieldName} className="error_summary reg_error_summary" dangerouslySetInnerHTML={{ __html: fieldData.error }}/>
                      ) : null
                    )}
                  </div>
                )}

                {error && (
                  <div className="error_container">
                    <p className="error_summary reg_error_summary" dangerouslySetInnerHTML={{ __html: error }} />
                  </div>
                )}

                {/* No Memberships Checkbox */}
                <div className="no-memberships-section phone-verification">
                  <div className="checkbox-group">
                    <input
                      type="checkbox"
                      id="no-memberships"
                      checked={noMemberships}
                      onChange={(e) => handleNoMembershipsChange(e.target.checked)}
                      disabled={loading}
                    />
                    <label htmlFor="no-memberships" className="checkbox-label">
                      I acknowledge that I do not hold a membership with USEF, EC or FEI.
                    </label>
                  </div>
                </div>

                <div className={`full submit ${props.fromRegister ? 'fromregister' : ''}`}>
                  <button
                    type="button"
                    className={`button primary-button ${loading ? 'button-loading' : verifyPhoneLoading ? 'disabled' : '' }`}
                    disabled={loading}
                    onClick={handleNoMembershipSubmit}
                  >
                    <span className="btn-text">Continue</span>
                    <svg className="loading-spinner" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3">
                      <circle className="spinner-circle" cx="12" cy="12" r="10" strokeOpacity="0.25" />
                      <path className="spinner-path" d="M22 12a10 10 0 0 1-10 10"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Step 5: Success/Completion */}
        {currentStep === 5 && success && (
          <div className="div-responsive loginverificationcss">
            <div className="registration-container">
              <div className="success-header">
                <div className="success-content">
                  {props.fromRegister ? <h2>Registration Complete</h2> : <h2>Identity Verification Complete</h2>}
                  <p className="success-subtitle">Your account has been successfully {noMemberships || props.fromRegister ? 'set up' : 'verified'}</p>
                </div>
              </div>

              <div className="success-details">
                <div className="success-checkmarks">                    
                  {props.fromRegister ? (
                    <div>
                      <h3>Thank you for registering for {Sgl.company_name}</h3>
                      <p>A confirmation email has been sent to you. You must access your email and confirm the registration prior to logging in.</p>
                      <br />
                    </div>  
                  ) : null}

                  <div className="success-item">
                    <img src={tick_icon} alt="Check" />
                    <span>Identity {noMemberships ? 'registration' : 'verification'} completed</span>
                  </div>
                  {!noMemberships && (
                    <div className="success-item">
                      <img src={tick_icon} alt="Check" />
                      <span>Account linked to membership records</span>
                    </div>
                  )}
                  <div className="success-item">
                    <img src={tick_icon} alt="Check" />
                    <span>{noMemberships ? 'Account setup complete' : 'Ready for event registration'}</span>
                  </div>
                </div>

                <div className="success-info">
                  <p>
                    {noMemberships 
                      ? "Your account has been set up. While you don't have organization memberships on file, you can still access many features of the platform."
                      : `You can now participate in equestrian events as an exhibitor. Your membership information has been securely recorded in our system.`
                    }
                  </p>
                </div>
                
                {props.fromRegister && warning && (
                  <div className="no-memberships-section" style={{ fontSize: "13px", color: "#92400e", lineHeight: "1.4" }}>
                    {warning}
                  </div>
                )}

                <div className={`full submit ${props.fromRegister ? 'fromregister' : ''}`}>
                  <button
                    className="button primary-button"
                    onClick={verificationComplete}
                  >
                    Continue
                  </button>
                </div>

              </div>
            </div>
          </div>
        )}

        {!props.fromRegister ? 
          <div className="copyright-text">
            {process.env.REACT_APP_COPYRIGHT_TEXT}
          </div>
         : null}
      </div>
    </div>
  );
}

export default LoginVerification;